module.exports = __webpack_public_path__ + "static/media/rightArrow.1b55a4d7.svg";